import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Sidebar from "./Sidebar";
import PartyScreen from "./PartyScreen";
import MasterScreen from "./MasterScreen";
import PurchaseScreen from "./PurchaseScreen";
import DeliveryScreen from "./DeliveryScreen";
import ProductionScreen from "./ProductionScreen";
import InvoiceScreen from "./InvoiceScreen";
import ReceiptScreen from "./ReceiptScreen";
import AllReports from "./AllReports";
import StockScreen from "./StockScreen";


import "./App.css";

function MainLayout() {
  const [page, setPage] = useState("PARTY LIST");
  const [history, setHistory] = useState([]);

  const handleSelect = (item) => {
    if (item === "BACK") {
      if (history.length > 0) {
        const previous = history[history.length - 1];
        setHistory(history.slice(0, -1));
        setPage(previous);
      }
      return;
    }

    if (item === "EXIT") {
      const confirmExit = window.confirm("Are you sure you want to exit?");
      if (confirmExit) {
        window.close();
        window.location.href = "/";
      }
      return;
    }

    setHistory(prev => [...prev, page]);
    setPage(item);
  };

  // 🔥 GO BACK function — goes to previous screen
  const goBack = () => {
    if (history.length > 0) {
      const previous = history[history.length - 1];
      setHistory(prev => prev.slice(0, -1));
      setPage(previous);
    } else {
      setPage("PARTY LIST"); // fallback if no history
    }
  };

  const renderPage = () => {
    switch (page) {
      case "PARTY LIST":
        return <PartyScreen />;
      case "MASTER":
        return <MasterScreen goHome={goBack} />;
      case "PURCHASE":
        return <PurchaseScreen goHome={goBack} />;
      case "STOCK":
        return <StockScreen goHome={goBack} />;
      case "DELIVERY":
        return <DeliveryScreen goHome={goBack} />;
      case "INVOICE":
        return <InvoiceScreen goHome={goBack} />;
      case "RECEIPT":
        return <ReceiptScreen goHome={goBack} />;
      case "ALL REPORTS":
        return <AllReports goHome={goBack} />;
      default:
        return <PartyScreen />;
    }
  };

  return (
    <div className="app-root">
      <header className="brand">ORANGE TRADINGS</header>
      <Sidebar onSelect={handleSelect} />
      <div className="app-window">
        {renderPage()}
      </div>
    </div>
  );
}


function App() {
  return (
    <Router>
      <Routes>
        {/* Main App */}
        <Route path="/" element={<MainLayout />} />

      
      </Routes>
    </Router>
  );
}

export default App;
